import { api, ApiError } from "@/api/client";
import { setOwner, lockOfflineWork, lockVersion, beginIdentityCheck, identityCheckIsCurrent } from "./store";
import type { Owner } from "./types";

/** Only the latest verification may unlock this origin's prepared work. */
export async function refreshOwner(unlock = false) {
    const generation = lockVersion();
    if (generation && !unlock) throw new DOMException("Workspace locked", "AbortError");
    const check = await beginIdentityCheck();
    let owner: Owner;
    try {
        owner = (await api.raw<Owner>("/offline/context")).data;
        if (!owner || typeof owner.instance !== "string" || !owner.instance || !Number.isInteger(owner.user_id)
            || owner.user_id <= 0 || !Number.isInteger(owner.company_id) || typeof owner.lang !== "string"
            || !["execution", "design", "consulting"].includes(owner.workspace)) throw new Error("Invalid workspace identity");
    } catch (error) {
        if (error instanceof ApiError && [401, 403].includes(error.status)
            && generation === lockVersion() && await identityCheckIsCurrent(check)) await lockOfflineWork().catch(() => {});
        throw error;
    }
    try {
        if (!await setOwner(owner, generation, check)) throw new DOMException("Session changed", "AbortError");
    } catch (error) {
        if (!(error instanceof DOMException && error.name === "AbortError")) {
            let current = true;
            try { current = await identityCheckIsCurrent(check); } catch { /* Fail closed if local identity storage is unavailable. */ }
            if (current) await lockOfflineWork().catch(() => {});
        }
        throw error;
    }
    return owner;
}
